module.exports = __webpack_public_path__ + "img/10.3846a91c.png";